var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"none"},attrs:{"lastActivity":_vm.lastActivity}})}
var staticRenderFns = []

export { render, staticRenderFns }